import { Badge } from "@/components/ui/badge";

const MAP = {
  pending_payment: ["Menunggu Pembayaran", "bg-amber-50 text-amber-700 border-amber-200"],
  waiting_confirmation: ["Menunggu Konfirmasi", "bg-blue-50 text-blue-700 border-blue-200"],
  paid: ["Lunas", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  rejected: ["Ditolak", "bg-rose-50 text-rose-700 border-rose-200"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = MAP[status] || [status, ""];
  return <Badge variant="outline" className={`rounded-full ${cls}`} data-testid={testId}>{label}</Badge>;
};

export const PageHeader = ({ label, title, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 fade-up">
    <div>
      {label && <p className="text-xs uppercase tracking-widest text-zinc-400 font-bold mb-2">{label}</p>}
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-zinc-900" data-testid="page-title">{title}</h1>
    </div>
    {children}
  </div>
);
